<template>
  <BaseComponent :isReady="isReady">
    <ContentLoader slot="loader" viewBox="0 0 343 200" :speed="2" primaryColor="#f2f2f2" secondaryColor="#ffffff">
      <rect x="0" y="0" rx="8" ry="8" width="100" height="16" />
      <rect x="286" y="592" rx="0" ry="0" width="1" height="0" />
      <rect x="0" y="24" rx="8" ry="8" width="343" height="16" />
      <rect x="0" y="48" rx="8" ry="8" width="343" height="16" />
      <rect x="0" y="72" rx="8" ry="8" width="148" height="16" />
    </ContentLoader>
    <slot></slot>
  </BaseComponent>
</template>
<script lang="ts">
import { ContentLoader, BaseComponent } from '@tencent/wphk-components-content-loader';
import { defineComponent } from 'vue-demi';
export default defineComponent({
  name: 'TncSkeleton',
  props: {
    isReady: Boolean,
  },
  components: {
    ContentLoader,
    BaseComponent,
  },
});
</script>
